<template>
  <div>
    <va-modal
      class="modal activity"
      v-model="showFicheEntreprise"
      cancelClass="none"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="saveEntreprise"
      v-on:cancel="closeModal"
      noEscDismiss
      :noOutsideDismiss="isModified"
    >
      <div class="forcewidth">
        <div
          v-if="entreprise.afpf"
          class="row row-inside bandeau-afpf"
          :style="{
            'background-color': this.$themes.info
          }"
        >
          <div class="flex md12 flex-center">
            <h3 class="warning-text flex-center">
              Entreprise AFPF
            </h3>
          </div>
        </div>
        <div
          v-if="entreprise.closure_date || entreprise.liquidation"
          class="row row-inside bandeau-activity"
          :style="{
            'background-color': entreprise.closure_date
              ? this.$themes.danger
              : this.$themes.warning,
          }"
        >
          <div class="flex md12 flex-center">
            <h3 class="warning-text flex-center">
              Entreprise
              {{ entreprise.closure_date ? "inactive" : "en liquidation" }}
            </h3>
          </div>
        </div>

        <div
          class="row row-inside bandeau-spacer"
          v-if="entreprise.closure_date || entreprise.liquidation || entreprise.afpf"
        ></div>
        <div class="row">
          <div class="flex md6">
            <h5 :style="{ color: this.$themes.primary }">
              {{ entreprise.nom }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="flex md6">
            <va-tabs
              grow
              v-model="tabsState"
            >
              <va-tab>Fiche entreprise</va-tab>
              <va-tab v-show="entreprise.identreprise">Formation</va-tab>
              <va-tab v-show="entreprise.identreprise">Galerie
                {{ entreprise.listImage && entreprise.listImage.length > 0
                  ? "(" + entreprise.listImage.length + ")"
                  : ""
                }}</va-tab>
              <va-tab v-show="entreprise.identreprise">Adhésions</va-tab>
              <va-tab v-show="entreprise.identreprise">Etablissements et contacts</va-tab>
              <va-tab
                v-show="entreprise.identreprise"
                :style="{ color: colorRetourTab }"
              >Retours
                {{
                  entreprise.retourStatus
                  ? "(" + entreprise.retourStatus + ")"
                  : ""
                }}</va-tab>

            </va-tabs>
            <va-separator />
          </div>

          <div class="flex md6">
            <div class="row row-inside">
              <div
                class="flex md2"
                v-show="entrepriseStatuts.isactive"
              ></div>
              <div class="flex md3">
                <div class="row row-inside">
                  <div class="flex offset--md2 md3">
                    <va-popover
                      message="Envoi de bulletin d'adhésion"
                      placement="top"
                    >
                      <va-button
                        class="offset-top"
                        flat
                        large
                        color="primary"
                        icon="vuestic-iconset vuestic-iconset-forms"
                        @click="openGestionBulletin"
                      />
                    </va-popover>
                  </div>
                  <!-- <div class="flex offset--md2 md3">
                    <va-popover message="Google street view" placement="top">
                      <va-button
                        class="offset-top"
                        flat
                        large
                        disabled
                        color="primary"
                        icon="fa fa-eye"
                        @click
                      />
                    </va-popover>
                  </div> -->
                  <div class="flex md3">
                    <va-popover
                      :message="infogreffeMsg"
                      placement="top"
                    >
                      <va-button
                        class="offset-top"
                        flat
                        large
                        color="primary"
                        icon="fa fa-info"
                        @click="showInfoGreffe(entreprise)"
                        :disabled="!entreprise.siret"
                      />
                    </va-popover>
                  </div>
                  <div class="flex md3">
                    <va-popover
                      message="Société.com"
                      placement="left"
                    >
                      <va-button
                        class="offset-top"
                        flat
                        large
                        color="primary"
                        icon="fa fa-book"
                        @click="showSocieteCom(entreprise)"
                      />
                    </va-popover>
                  </div>
                </div>
              </div>

              <div class="flex md2">
                <va-toggle
                  small
                  v-model="entrepriseStatuts.isactive"
                  label="En activité"
                />
              </div>

              <div
                class="flex md2"
                v-show="!entrepriseStatuts.isactive"
              >
                <div class="row row-inside">
                  <div class="flex md12">
                    <va-date-picker
                      class="warning-date px-2"
                      :config="{ dateFormat: 'Y-m-d' }"
                      label="Fin d'activité"
                      v-model="entrepriseStatuts.closure_date"
                      :error="closureDateCheck.check"
                      removable
                    />
                  </div>
                  <div
                    class="flex md12"
                    v-show="closureUser || closureLastChange"
                  >
                    <p>
                      {{ closureStatusChange() }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="flex md2">
                <va-date-picker
                  class="px-2"
                  :config="{ dateFormat: 'Y-m-d' }"
                  label="Début d'activité"
                  v-model="entrepriseStatuts.creation_date"
                  :error="creationDateCheck.check"
                />
              </div>
              <div class="flex md3">
                <div class="row row-inside">
                  <div class="flex md12 mb-0 pb-0">
                    <va-toggle
                      small
                      v-model="entrepriseStatuts.liquidation"
                      label="Liquidation"
                    />
                  </div>
                  <div class="flex md12 ma-0 pa-0 liquidationname">
                    {{
                      entrepriseStatuts.liquidation
                      ? entreprise.userliquidation
                      : ""
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tabsState === 0">
          <div class="row row-inside">
            <div class="flex md1">
              <va-button
                class="custom-button"
                small
                :disabled="!entreprise.email"
                @click="openCourriel(entreprise)"
              >Courriel</va-button>
            </div>
            <div class="flex md1">
              <va-button
                class="custom-button"
                small
                disabled
                @click
              >SMS</va-button>
            </div>

            <div class="flex md5">
              <div class="row row-inside">
                <div class="flex md4">
                  <va-button
                    small
                    class="custom-button"
                    :color="infosJournal.color"
                    @click="openJournal"
                  >{{ infosJournal.text }}</va-button>
                </div>
                <div class="flex md5">
                  <va-toggle
                    small
                    disable
                    v-model="entrepriseStatuts.mapa"
                    label="Protection juridique MAPA"
                  />
                </div>
                <div class="flex md3">
                  <va-toggle
                    small
                    v-model="entrepriseStatuts.norelance"
                    label="Ne pas relancer"
                  />
                </div>
              </div>
            </div>
            <div class="flex md2">
              <div
                class="row row-inside align-right"
                v-show="modificationStatus"
              >
                <div class="flex md9 offset--md3">Dernière modification:</div>
                <div class="flex md9 offset--md3">
                  <p class="text--secondary small-text">
                    {{ modificationStatus }}
                  </p>
                </div>
              </div>
            </div>
            <div class="flex md3">
              <div class="row row-inside align-right">
                <div class="flex md4">
                  <va-badge
                    class="fullwidth"
                    :color="verificationStatuts.color"
                  >{{ verificationStatuts.text }}</va-badge>
                </div>
                <div class="flex md6">
                  <va-checkbox
                    class="align-right"
                    label="Vérifier l'entreprise"
                    v-model="verifierEntreprise"
                  />
                </div>
                <div class="flex md10">
                  <p class="text--secondary small-text">
                    {{ verificationStatuts.msg }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-2">
            <h5
              class="entreprise-siege-titre"
              :style="{ color: this.$themes.primary }"
            >
              Informations Siège:
            </h5>
            <div class="row">
              <div class="flex xs10 md7 padded-right">
                <dashboard-entreprise-infos
                  ref="entrepriseInfoComp"
                  :entrepriseInfos="entreprise"
                  v-on:infosChanged="updateInfosE"
                />

                <div class="row mt-3 mb-3">
                  <div class="flex md12">
                    <div class="row row-inside">
                      <div class="flex md5">
                        <div class="row row-inside">
                          <h5
                            class="mr-3"
                            :style="{ color: this.$themes.primary }"
                          >
                            {{ $t("gestionAdhesion.opefstatuts") }}
                          </h5>

                          <va-badge :color="opefStatutsVar.color">
                            {{ opefStatutsVar.msg }}
                          </va-badge>
                        </div>
                      </div>
                      <div class="flex md7 offset-adhesion">
                        <dashboard-autres-adhesions :identreprise="entreprise.identreprise" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="flex md7">
                    <dashboard-adhesions
                      ref="adhesionmng"
                      :identreprise="entreprise.identreprise"
                      :toupdate="updateAdhesion"
                      v-on:opefStatuts="updateOpef"
                      v-on:infosChanged="updateInfosADH"
                      @updatedone="updateAdhesion = false"
                    ></dashboard-adhesions>
                  </div>
                  <div class="flex md5">
                    <div class="row row-inside">
                      <div class="flex md4">
                        <div class="row row-inside">
                          <va-badge
                            v-if="entreprise.envoiN1"
                            class="fullwidth"
                            color="success"
                          >Niveau 1</va-badge>
                        </div>
                        <div
                          class="row row-inside"
                          v-if="entreprise.envoiN1"
                        >
                          <p class="dateenvoi">
                            {{ entreprise.envoiN1.dateenvoi }}
                          </p>
                        </div>
                      </div>
                      <div class="flex md4">
                        <div class="row row-inside">
                          <va-badge
                            v-if="entreprise.envoiN2"
                            class="fullwidth"
                            color="warning"
                          >Niveau 2</va-badge>
                        </div>
                        <div
                          class="row row-inside"
                          v-if="entreprise.envoiN2"
                        >
                          <p class="dateenvoi">
                            {{ entreprise.envoiN2.dateenvoi }}
                          </p>
                        </div>
                      </div>
                      <div class="flex md4">
                        <div class="row row-inside">
                          <va-badge
                            v-if="entreprise.envoiN3"
                            class="fullwidth"
                            color="danger"
                          >Niveau 3</va-badge>
                        </div>
                        <div
                          class="row row-inside"
                          v-if="entreprise.envoiN3"
                        >
                          <p class="dateenvoi">
                            {{ entreprise.envoiN3.dateenvoi }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <dashboard-comments-list
                    v-show="entreprise.identreprise"
                    class="relance-container-list"
                    ref="relancemng"
                    :identreprise="entreprise.identreprise"
                    setheight="15"
                  ></dashboard-comments-list>
                </div>
              </div>

              <div class="flex md5 padded-left">
                <dashboard-contact-infos
                  ref="contactInfoComp"
                  :contactInfos="contact"
                  v-on:infosChanged="updateInfosC"
                />
                <dashboard-adresse-infos
                  ref="adresseInfoComp"
                  :adresseInfos="adresse"
                  v-on:infosChanged="updateInfosA"
                  v-on:copy2clipboard="copy2cliboard"
                />
                <dashboard-relances-list
                  v-show="entreprise.identreprise"
                  class="relance-container-list"
                  ref="relancemng"
                  :identreprise="entreprise.identreprise"
                  setheight="18"
                ></dashboard-relances-list>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tabsState === 1">
          <dashboard-formation
            ref="formationModule"
            v-model="entreprise.nb_salaries"
            v-if="entreprise.identreprise"
            :identreprise="entreprise.identreprise"
            v-on:infosChanged="updateInfosF"
          />
        </div>
        <div v-if="tabsState === 2">
          <dashboard-galerie
            v-if="entreprise.identreprise"
            :identreprise="entreprise.identreprise"
          />
        </div>

        <div v-show="tabsState === 3">
          <dashboard-adhesions-list
            class="half-height mb-2"
            v-show="entreprise.identreprise"
            :identreprise="entreprise.identreprise"
            :entrepriseName="entreprise.nom"
            setheight="8"
            v-on:adhesionschange="adhesionsUpdate(true)"
          ></dashboard-adhesions-list>
          <dashboard-autres-adhesions-list
            class="half-height mt-2"
            v-show="entreprise.identreprise"
            :identreprise="entreprise.identreprise"
            v-on:adhesionschange="adhesionsUpdate(false)"
          ></dashboard-autres-adhesions-list>
        </div>
        <div v-show="tabsState === 4">
          <dashboard-contact-list
            v-show="entreprise.identreprise"
            :entreprise="entreprise"
            v-on:updateEntreprise="updateEntreprise(4)"
          ></dashboard-contact-list>
        </div>
        <div v-show="tabsState === 5">
          <tab-retours
            v-show="entreprise.identreprise"
            :identreprise="entreprise.identreprise"
          ></tab-retours>
        </div>
      </div>
    </va-modal>
    <textarea
      class="hidden-input"
      id="copy-clipboard"
      :value="clipboardAdresse"
    />
    <envoi-bulletins-adhesions
      :identreprise="entreprise.identreprise"
      v-model="showEnvoiBulletins"
    />
    <gestion-journal
      :identreprise="entreprise.identreprise"
      v-model="showJournal"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, isEqual } from "lodash";
import DashboardAdresseInfos from "./components/DashboardAdresseInfos";
import DashboardEntrepriseInfos from "./components/DashboardEntrepriseInfos";
import DashboardContactInfos from "./components/DashboardContactInfos";
import DashboardAdhesions from "./DashboardAdhesions";
import DashboardOtherAdhesions from "./components/DashboardOtherAdhesions";
import DashboardAutresAdhesions from "./components/DashboardAutresAdhesions";

import DashboardRelancesList from "./components/DashboardRelancesList";
import DashboardCommentsList from "./components/DashboardCommentsList";
import DashboardAdhesionsList from "./components/DashboardAdhesionsList";
import DashboardAutresAdhesionsList from "./components/DashboardAutresAdhesionsList";
import DashboardContactList from "./components/DashboardContactList";
import DashboardGalerie from "./components/DashboardGalerie";
import DashboardFormation from "./tabs/DashboardFormation";
import EnvoiBulletinsAdhesions from "./components/EnvoiBulletinsAdhesions.vue";
import GestionJournal from "./components/GestionJournal.vue";

import ChangeLevel from "../campaigns/ChangeLevel.vue";

import TabRetours from "./components/TabRetours";

import moment from "moment";

import uuid from "uuid/v4";

export default {
  name: "ficheEntreprise",
  components: {
    DashboardAdhesions,
    DashboardOtherAdhesions,
    DashboardAutresAdhesions,
    DashboardEntrepriseInfos,
    DashboardContactInfos,
    DashboardAdresseInfos,
    DashboardRelancesList,
    DashboardCommentsList,
    DashboardAdhesionsList,
    DashboardContactList,
    DashboardAutresAdhesionsList,
    DashboardFormation,
    DashboardGalerie,
    TabRetours,
    EnvoiBulletinsAdhesions,
    GestionJournal,
    ChangeLevel,
  },
  props: ["value", "tableentreprise", "isafpf"],
  data() {
    return {
      syndicat: "unpf",
      changeLevelId: null,
      showJournal: false,
      closureLastChange: null,
      closureUser: null,
      modificationStatus: null,
      clipboardAdresse: "",
      updateAdhesion: false,
      updateAutresAdhesion: false,
      //terrible design
      closeNow: 0,
      dateCompare: new Date(),
      holder: false,
      tabsState: 0,
      infosStatutsUpdated: false,
      formationInfosChanged: false,
      contactInfosChanged: false,
      entrepriseInfosChanged: false,
      adresseInfosChanged: false,
      adhesionInfosChanged: false,
      opefStatuts: "danger",
      verificationStatuts: {
        text: "Jamais vérifié",
        color: "danger",
        msg: ""
      },
      creationDateCheck: { check: false, message: ["Ne peut pas être vide"] },
      closureDateCheck: { check: false, message: ["Ne peut pas être vide"] },
      isNew: false,
      adhesionsList: [],
      entreprise: {},
      adresse: {},
      siege: {},
      contact: {},
      showFicheEntreprise: false,
      entrepriseStatuts: {
        isactive: true,
        norelance: false,
        closure_date: null,
        creation_date: null,
        mapa: false,
        journal: false,
        liquidation: false
      },
      verifierEntreprise: false,
      entrepriseStatutsInit: {
        isactive: true,
        norelance: false,
        closure_date: null,
        creation_date: null,
        mapa: false,
        journal: false,
        liquidation: false
      },
      showEnvoiBulletins: false
    };
  },
  mounted() {
    this.resetValues();
    this.showFicheEntreprise = this.value; // initialize internal variables
  },
  computed: {
    infosJournal: function () {
      if (this.entreprise.journal === 1) {
        return { color: "success", text: "Abonné" };
      } else if (this.entreprise.journal === 2) {
        return { color: "warning", text: "Contacts Abonnés" };
      } else {
        return { color: "danger", text: "Non abonné" };
      }
    },

    colorRetourTab: function () {
      if (
        this.entreprise.retourStatus &&
        this.entreprise.retourStatus === "Définitif"
      ) {
        return this.$themes.danger;
      } else if (
        this.entreprise.retourStatus &&
        parseInt(this.entreprise.retourStatus) >= 3
      ) {
        return this.$themes.danger;
      } else if (this.entreprise.retourStatus) {
        return this.$themes.warning;
      } else {
        return;
      }
    },
    infogreffeMsg: function () {
      if (this.entreprise.siret) {
        return "InfoGreffe.fr";
      }
      return "SIRET nécessaire pour accéder InfoGreffe.fr";
    },
    opefStatutsVar: function () {
      if (this.opefStatuts === "success") {
        return { color: this.opefStatuts, bool: true, msg: "Adhérent" };
      } else if (this.opefStatuts === "warning") {
        return { color: this.opefStatuts, bool: false, msg: "Expiré" };
      } else if (this.opefStatuts === "info") {
        return { color: this.opefStatuts, bool: false, msg: "Adhésion liée" };
      } else {
        return { color: "danger", bool: false, msg: "Non adhérent" };
      }
    },
    isModified: function () {
      return (
        this.entrepriseInfosChanged ||
        this.formationInfosChanged ||
        this.contactInfosChanged ||
        this.adresseInfosChanged ||
        this.adhesionInfosChanged ||
        this.infosStatutsUpdated ||
        this.verifierEntreprise
      );
    },
    saveMessage: function () {
      return this.isModified
        ? "Sauvegarder les modifications"
        : "Fermer la fiche";
    }
  },
  watch: {
    entrepriseStatuts: {
      deep: true,
      handler() {
        if (!isEqual(this.entrepriseStatuts, this.entrepriseStatutsInit)) {
          this.infosStatutsUpdated = true;
        } else {
          this.infosStatutsUpdated = false;
        }
      }
    },
    value() {
      // Parent property changed; update internal variables
      this.showFicheEntreprise = this.value;
      if (!this.value) {
        this.resetValues();
      } else if (!this.tableentreprise.identreprise) {
        this.resetValues();
        this.isNew = true;
      } else {
        this.isNew = false;
        this.loadEntreprise(this.tableentreprise.identreprise);
      }
    }
  },
  methods: {
    changeLevel(dataEntreprises) {
      console.log("Level change", dataEntreprises)
      this.changeLevelId = dataEntreprises.identreprise;
      console.log("Level change", this.changeLevelId);

    },
    openJournal() {
      this.showJournal = !this.showJournal;
    },
    openGestionBulletin() {
      console.log("openadhesion");
      this.showEnvoiBulletins = !this.showEnvoiBulletins;
    },
    closureStatusChange() {
      if (this.closureUser && this.closureLastChange) {
        return this.closureUser + " - " + this.closureLastChange;
      } else if (this.closureUser) {
        return this.closureUser;
      } else if (this.closureUser) {
        return this.closureLastChange;
      } else {
        return null;
      }
    },
    copy2cliboard(adresse) {
      try {
        let toCopy =
          this.$refs.entrepriseInfoComp.entrepriseInfosMod.nom + "\r\n";
        let contact = this.$refs.contactInfoComp.contactInfosMod;
        // format name
        let contactString = "";
        if (contact.titre && contact.titre === "SOCIÉTÉ") {
          if (contact.titre_societe) {
            contactString =
              contact.titre_societe[0].toUpperCase() +
              contact.titre_societe.slice(1).toLowerCase();
          }
          if (contact.prenom_societe) {
            contactString = contactString ? contactString + " " : "";
            contactString +=
              contact.prenom_societe[0].toUpperCase() +
              contact.prenom_societe.slice(1).toLowerCase();
          }
          if (contact.nom_societe) {
            contactString = contactString ? contactString + " " : "";
            contactString += contact.nom_societe.toUpperCase();
          }
        } else {
          if (contact.titre) {
            contactString =
              contact.titre[0].toUpperCase() +
              contact.titre.slice(1).toLowerCase();
          }
          if (contact.prenom) {
            contactString +=
              " " +
              contact.prenom[0].toUpperCase() +
              contact.prenom.slice(1).toLowerCase();
          }
          if (contact.nom) {
            contactString += " " + contact.nom.toUpperCase();
          }
        }

        if (contactString) {
          toCopy += contactString + "\r\n";
        }

        toCopy += adresse;

        if (this.$refs.entrepriseInfoComp.portableNumber) {
          toCopy += "\r\n" + this.$refs.entrepriseInfoComp.portableNumber;
        } else if (contact.portable) {
          toCopy += "\r\n" + contact.portable;
        }

        this.clipboardAdresse = toCopy;
        // needed to insure that the value is transfered to the hidden textarea
        this.$nextTick(() => {
          let adresse2copy = document.querySelector("#copy-clipboard");
          adresse2copy.setAttribute("type", "text");
          adresse2copy.select();
          document.execCommand("copy");
          this.launchEpicmaxToast("Adresse copiée");
        });
      } catch (e) {
        this.launchEpicmaxToast("Erreur lors de la copie");
      }
    },
    updateAfterLevelChange() {
      this.changeLevelId = null;
      this.loadEntreprise(this.tableentreprise.identreprise);
      this.$emit("update", this.tableentreprise.identreprise);
    },
    updateEntreprise(onglet) {
      this.loadEntreprise(this.tableentreprise.identreprise, onglet);
      this.$emit("update", this.tableentreprise.identreprise);
    },
    adhesionsUpdate(directe) {
      if (directe) {
        this.updateAdhesion = true;
      } else {
        this.updateAutresAdhesion = true;
      }
      this.$emit("update", this.tableentreprise.identreprise);
    },

    updateInfosADH(value) {
      this.adhesionInfosChanged = value;
    },
    updateInfosE(value) {
      this.entrepriseInfosChanged = value;
    },
    updateInfosF(value) {
      this.formationInfosChanged = value;
    },
    updateInfosC(value) {
      this.contactInfosChanged = value;
    },
    updateInfosA(value) {
      this.adresseInfosChanged = value;
    },
    updateOpef(value) {
      if (this.opefStatuts === "success") {
        return;
      }
      this.opefStatuts = value;
    },
    updateOpefTierce(value) {
      console.log(value);
      this.opefStatuts = value;
    },
    openCourriel(entreprise) {
      let email = entreprise.email;
      window.location.href = "mailto:" + email;
    },
    showSocieteCom(entreprise) {
      this.isaction = true;
      let url = "https://www.societe.com/cgi-bin/search?champs=";
      let search = entreprise.siret
        ? entreprise.siret.substring(0, 9)
        : entreprise.nom;

      window.open(url + search, "_blank");
    },
    showInfoGreffe(entreprise) {
      this.isaction = true;
      let url = "https://www.infogreffe.fr/entreprise-societe/";
      let search = entreprise.siret
        ? entreprise.siret.substring(0, 9)
        : entreprise.nom;

      window.open(
        url + search + ".html?typeProduitOnglet=EXTRAIT&afficherretour=false",
        "_blank"
      );
    },

    resetValues() {
      this.showJournal = false;
      this.modificationStatus = null;
      this.closeNow = 0;
      this.adhesionInfosChanged = false;
      this.formationInfosChanged = false;
      this.contactInfosChanged = false;
      this.entrepriseInfosChanged = false;
      this.adresseInfosChanged = false;
      this.opefStatuts = "danger";
      this.nb_salaries = "";
      this.changeLevelId = null;
      this.entreprise = {
        identreprise: null,
        nom: null,
        contact_idcontact: null,
        enseigne: null,
        siret: null,
        n_societaire: null,
        pavillon_de_france: null,
        decision_justice: null,
        zone_activite: null,
        etat: null,
        email: null,
        telephone: null,
        siege_id: null,
        portable: null,
        site_internet: null,
        code_ape: null,
        forme_juridique: null,
        isactive: true,
        liquidation: false,
        mapa: -1,
        retours: 0,
        listImage: []
      };
      this.adresse = {
        id: null,
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null
      };
      this.siege = {
        idetablissement: null,
        entreprise_identreprise: null,
        adresse_id: null,
        nom: null,
        contact_idcontact: null,
        telephone: null,
        email: null,
        nb_salaries: null,
        siret: null
      };
      this.contact = {
        idcontact: null,
        entreprise_identreprise: null,
        titre: null,
        nom: null,
        prenom: null,
        telephone: null,
        email: null,
        adresse_id: null,
        isvip: 0
      };
      this.closureDateCheck.check = false;
      this.creationDateCheck.check = false;
      this.entrepriseStatuts = {
        isactive: true,
        norelance: false,
        closure_date: null,
        creation_date: null,
        mapa: false,
        journal: false,
        liquidation: false
      };
      this.entrepriseStatutsInit = {
        isactive: true,
        norelance: false,
        closure_date: null,
        creation_date: null,
        mapa: false,
        journal: false,
        liquidation: false
      };
      this.verificationStatuts = {
        text: "Jamais vérifié",
        color: "danger",
        msg: ""
      };
      this.verifierEntreprise = false;
      this.tabsState = 0;
    },
    loadEntreprise(id, tab) {
      this.dateCompare = new Date();
      let pastYear = this.dateCompare.getFullYear() - 1;
      this.dateCompare.setFullYear(pastYear);
      this.verifierEntreprise = false;
      this.changeLevelId = null;

      this.opefStatuts = "danger";
      axios
        .get("/api/entreprise-infos", {
          params: {
            id: id
          }
        })
        .then(res => {
          console.log("entreprise infos", res.data);
          this.resetValues();
          if (res.data.etablissement.contact)
            this.contact = cloneDeep(res.data.etablissement.contact);

          if (res.data.etablissement.adress)
            this.adresse = cloneDeep(res.data.etablissement.adress);
          if (this.siege) this.siege = cloneDeep(res.data.etablissement);
          this.entreprise = cloneDeep(res.data);
          //temp to revise when several etablissement
          this.entreprise.nb_salaries = this.siege.nb_salaries;
          this.entreprise.siret = this.siege.siret;
          res.data = {};
          delete this.entreprise.etablissement;
          delete this.siege.adress;
          delete this.siege.contact;

          this.entrepriseStatuts = {
            isactive: this.entreprise.isactive,
            norelance: this.entreprise.norelance,
            closure_date: this.entreprise.closure_date,
            creation_date: this.entreprise.creation_date,
            mapa: this.entreprise.mapa === 1 ? true : false,
            journal: this.entreprise.journal,
            liquidation: this.entreprise.liquidation
          };

          this.closureUser = this.entreprise.closureUser
            ? this.entreprise.closureUser
            : null;
          this.closureLastChange = this.entreprise.closureLastChange
            ? this.entreprise.closureLastChange
            : null;
          this.entrepriseStatutsInit = {
            isactive: this.entreprise.isactive,
            norelance: this.entreprise.norelance,
            closure_date: this.entreprise.closure_date,
            creation_date: this.entreprise.creation_date,
            mapa: this.entreprise.mapa === 1 ? true : false,
            journal: this.entreprise.journal,
            liquidation: this.entreprise.liquidation
          };

          if (this.entreprise.verificationStatuts) {
            let t = this.entreprise.verificationStatuts.date.split("-");
            let dateVerification = new Date(t[0], t[1] - 1, t[2]);
            this.verificationStatuts.msg =
              t[2] +
              "-" +
              t[1] +
              "-" +
              t[0] +
              "  " +
              this.entreprise.verificationStatuts.user;

            if (dateVerification > this.dateCompare) {
              // entreprise vérifiée dans l'année
              this.verificationStatuts.text = "Vérifié";
              this.verificationStatuts.color = "success";
            } else {
              this.verificationStatuts.text = "A vérifier";
              this.verificationStatuts.color = "warning";
            }
          } else {
            this.verificationStatuts.text = "Jamais vérifié";
            this.verificationStatuts.color = "danger";
          }

          if (this.entreprise.lastModification) {
            console.log("test2");
            let tmpLM = this.entreprise.lastModification;
            this.modificationStatus = moment(
              tmpLM.date_last_modification,
              "YYYY-MM-DD HH:mm:ss"
            ).format("DD-MM-YYYY");
            this.modificationStatus += " " + tmpLM.prenom + " " + tmpLM.nom;
          } else {
            this.modificationStatus = null;
          }
          if (tab) {
            this.tabsState = tab;
          }
        })
        .catch(err => console.log(err));
    },

    closeModal() {
      this.isNew = false;
      if (this.tableentreprise.identreprise) {
        this.$emit("update", this.tableentreprise.identreprise);
      }

      this.$emit("input", false);
    },
    async saveEntreprise() {
      this.showFicheEntreprise = true;
      if (!this.isModified) {
        this.$emit("input", false);
        return;
      }
      // check validity of the formular
      let isValid = this.$refs.contactInfoComp.isFormValid;
      isValid = isValid && this.$refs.entrepriseInfoComp.isFormValid;
      isValid = isValid && this.$refs.adresseInfoComp.isFormValid;

      if (!isValid) {
        this.launchEpicmaxToast("Formulaire non valide");
        return;
      }

      try {
        console.log("saving");

        // check if change in status (active/inactive) if yes, check that date is set

        // recover element that need to be updated
        // entreprise infos (always needed for update):
        let entrepriseMod = cloneDeep(
          this.$refs.entrepriseInfoComp.entrepriseInfosMod
        );
        entrepriseMod.isactive = this.entrepriseStatuts.isactive;
        entrepriseMod.liquidation = this.entrepriseStatuts.liquidation;
        let nb_salaries = entrepriseMod.nb_salaries;
        delete entrepriseMod.nb_salaries;
        if (this.infosStatutsUpdated) {
          if (
            !this.entrepriseStatuts.isactive &&
            !this.entrepriseStatuts.closure_date
          ) {
            this.closureDateCheck.check = true;
            this.launchEpicmaxToast("Date de fin d'activité non renseignée");
            return;
          } else {
            this.closureDateCheck.check = false;
            // remove the date if closure is not to true
            this.entrepriseStatuts.closure_date = this.entrepriseStatuts
              .isactive
              ? null
              : this.entrepriseStatuts.closure_date;
          }
          this.entrepriseInfosChanged = true;
          entrepriseMod.closure_date = this.entrepriseStatuts.closure_date;

          if (
            this.entrepriseStatuts.closure_date !==
            this.entrepriseStatutsInit.closure_date
          ) {
            entrepriseMod.closureDateChange = true;
          } else {
            entrepriseMod.closureDateChange = false;
          }

          if (!this.entrepriseStatuts.creation_date) {
            this.creationDateCheck.check = true;
            this.launchEpicmaxToast("Date de début d'activité non renseignée");
            return;
          }

          this.creationDateCheck.check = false;
          this.entrepriseInfosChanged = true;
          entrepriseMod.creation_date = this.entrepriseStatuts.creation_date;
        }
        let contactModTmp = cloneDeep(
          this.$refs.contactInfoComp.contactInfosMod
        );
        let contactMod;
        if (this.contactInfosChanged) {
          contactMod = contactModTmp;
          if (contactMod.titre === "SOCIÉTÉ") {
            contactMod.prenom = null;
          } else {
            contactMod.titre_societe = null;
            contactMod.nom_societe = null;
            contactMod.prenom_societe = null;
          }
        }

        let formationMod;
        if (this.formationInfosChanged) {
          formationMod = cloneDeep(this.$refs.formationModule.infosFormation);
        }

        let adresseModTmp = cloneDeep(
          this.$refs.adresseInfoComp.adresseInfosMod
        );
        let adresseMod;
        if (this.adresseInfosChanged) {
          adresseMod = adresseModTmp;
          entrepriseMod.code_postal = adresseMod.code_postal;
          entrepriseMod.ville = adresseMod.ville;
        }

        //need to update the siege transfert of information
        let siegeInfosChanged = false;
        let newSiret = entrepriseMod.siret;

        if (
          this.entrepriseInfosChanged &&
          this.siege.siret !== entrepriseMod.siret
        ) {
          siegeInfosChanged = true;
        }

        let mapaChanged = -1;
        if (this.entrepriseStatuts.mapa !== this.entrepriseStatutsInit.mapa) {
          mapaChanged = this.entrepriseStatuts.mapa;
        }

        // check that all required information are present for the firm validation
        if (this.verifierEntreprise) {
          if (
            !entrepriseMod.nom ||
            !entrepriseMod.siret ||
            entrepriseMod.code_ape == null ||
            entrepriseMod.forme_juridique == null ||
            nb_salaries == null
          ) {
            this.launchEpicmaxToast(
              "L'entreprise ne peut pas être vérifiée: nom, siret, code APE, forme juridique ou nombre d'employés non renseignés"
            );
            return;
          }

          if (!contactModTmp.nom || !contactModTmp.titre) {
            this.launchEpicmaxToast(
              "L'entreprise ne peut pas être vérifiée: information du contact manquante (nom ou titre)"
            );
            return;
          }

          if (
            !adresseModTmp.ville ||
            !adresseModTmp.adresse ||
            !adresseModTmp.code_postal
          ) {
            this.launchEpicmaxToast(
              "L'entreprise ne peut pas être vérifiée: information sur l'adresse manquante (adresse, ville ou code postal)"
            );
            return;
          }
        }

        let params = {
          isNew: this.isNew,
          norelance: this.entrepriseStatuts.norelance,
          entrepriseInfosChanged: this.entrepriseInfosChanged,
          contactInfosChanged: this.contactInfosChanged,
          adresseInfosChanged: this.adresseInfosChanged,
          entreprise: entrepriseMod,
          formation: formationMod,
          contact: contactMod,
          adresse: adresseMod,
          verifierEntreprise: this.verifierEntreprise,
          //need to revise that when managing several etablissements
          nb_salaries: nb_salaries,
          siege_siret: newSiret,
          siegeInfosChanged: siegeInfosChanged,
          mapaChanged: mapaChanged
        };

        if (this.isNew) {
          //notes: no possibilities to set the mapa status in that case
          if (this.isafpf) {
            params.entreprise.afpf = true;
          }
          let res = await axios.post("/api/create-new-entreprise", params);
          console.log(res.data[0])
          let newEntreprise = res.data[0];
          entrepriseMod.identreprise = newEntreprise.identreprise;

          this.$emit("create", newEntreprise);
        } else {
          let res = await axios.post("/api/update-entreprise-all", params);
          let identreprise = res.data;
          this.$emit("update", identreprise);
        }
        this.closeNow = 0;
        if (this.adhesionInfosChanged) {
          // need more safety in the save (confirm that the save is correct)
          // check which adhesion changed
          if (this.$refs.adhesionmng.infoUnpfUpdated) {
            this.closeNow += 1;
            this.$refs.adhesionmng.saveUnpf(entrepriseMod.identreprise);
          }
          if (this.$refs.adhesionmng.infoSpefUpdated) {
            this.closeNow += 1;
            this.$refs.adhesionmng.saveSpef(entrepriseMod.identreprise);
          }
        }

        if (this.closeNow === 0) this.$emit("input", false);
        this.launchEpicmaxToast("Entreprise sauvegardée");
      } catch (error) {
        console.log(error);
        if (error.response) {
          console.log(error.response);
        }
        this.launchEpicmaxToast("L'entreprise n'a pas pu être sauvegardée");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    },
    closeAfterMod(updatedEntreprise) {
      console.log("there");

      //terrible design wait for all adhesion to be done to close based on a counter...
      this.closeNow -= 1;
      if (this.closeNow === 0) {
        this.$emit("update", this.tableentreprise.identreprise);
        this.$emit("input", false);
      }
    }
  }
};
</script>

<style lang="scss">
.entreprise-siege-titre {
  position: relative;

  top: -0.65em;
}

.offset-adhesion {
  position: relative;
  top: -0.65em;
}

.offset-top {
  position: relative;
  top: -0.4em;
}

.offset-bottom {
  position: relative;
  top: -0.4em;
}

.padded-right {
  padding-right: 1%;
}

.padded-left {
  padding-left: 1%;
}

.forcewidth {
  width: 85vw;
  height: 80vh;
  overflow: auto;
}

@media screen and (min-resolution: 120dpi) {
  .forcewidth {
    width: 100vw;
    height: 75vh;
    overflow: auto;
  }
}

.fullwidth {
  width: 95%;
}

.align-right {
  float: right;
  clear: right;
}

.custom-button {
  width: 90%;
  border-color: #40e583;
  border-width: 2px;
  border-style: solid;
}

.small-text {
  font-size: 0.9em;
}

.half-height {
  overflow: auto;
  overflow-x: hidden;
  height: 35vh;
}

.hidden-input {
  height: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.dateenvoi {
  width: 100%;
  text-align: center;
}

.liquidationname {
  position: relative;
  height: 1em;
  top: -1em;
}

.bandeau-activity {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding: 1.25rem 1.875rem 1.5rem 1.5rem;
}

.bandeau-afpf {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding: 1.25rem 1.875rem 1.5rem 1.5rem;
}

.bandeau-spacer {
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding: 2rem;
}

.warning-text {
  color: white;
  font-size: 1.2rem;
}
</style>
